import React from "react"

const ListCarouselSlide = ({ children }) => (
  <div className="row listing-card-row carousel-slide">
    { children }
  </div>
)

export default ListCarouselSlide